import React, { useEffect, useMemo, useState } from 'react';
import { Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import IStoreState from 'store/IStoreState';
import { KFONE_ROLE, NavigationPath, RBAC_ROLE, Ic2fxComponentType, Ic2fxErrorType } from 'models/enum';
import { getDecodedB2cToken } from 'modules/auth/components/b2c/utils';
import HiringOverview from 'modules/hiring/pages/hiringOverview/hiringOverview';
import CandidatePipeline from 'modules/hiring/pages/candidatePipeline/candidatePipeline';
import CandidateProfile from 'modules/hiring/pages/candidateProfile/candidateProfile';
import { checkAppIsRunningInTeams } from '@/utilities/teamsRuntime';
import Ic2fxComponentWrapper from 'shared/components/ic2fxComponentWrapper';
import * as microsoftTeams from '@microsoft/teams-js';
import { loginUserSuccess } from '@/modules/auth/stateManagement/actionsCreator';

interface IHiringManagerRoutesProps {
  ssoToken?: string;
}

export const HiringManagerRoutesUnconnected = ({ ssoToken }: IHiringManagerRoutesProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  
  const effectiveToken = useMemo(() => {
    const lsToken = localStorage.getItem('AUTH_ID_TOKEN') || '';
    return ssoToken || lsToken || '';
  }, [ssoToken, location.search]);

  const isHiringManager = useMemo(() => {
    const decoded: any = getDecodedB2cToken(effectiveToken);
    const realmRoles: string[] = decoded?.realm_access?.roles || [];
    const topLevelRoles: string[] = decoded?.roles || [];
    const resourceRoles: string[] = Object.values(decoded?.resource_access ?? {})
      .flatMap((v: any) => v?.roles || []);
    const allRolesUpper = [...realmRoles, ...topLevelRoles, ...resourceRoles]
      .filter(Boolean)
      .map((r: any) => String(r).toUpperCase());
    return allRolesUpper.includes(KFONE_ROLE.HIRING_MANAGER.toUpperCase());
  }, [effectiveToken]);

   // Teams deep link support similar to EEApp
  //  useEffect(() => {
  //   if (!checkAppIsRunningInTeams()) {
  //     setIsFirstLoad(false);
  //     return;
  //   }

  //   const alreadyLoaded = sessionStorage.getItem('hasLoaded');
  //   const params = new URLSearchParams(window.location.search);
  //   const ignoreContext = params.get('ignoreContext') === 'true';

  //   if (isFirstLoad && !alreadyLoaded && !ignoreContext) {
  //     const initializeTeams = async () => {
  //       try {
  //         // Initialize Teams SDK v2 (async)
  //         await microsoftTeams.app.initialize();
          
  //         // Get context with error handling
  //         // Note: The 404 error you're seeing is likely from Teams SDK internally
  //         // trying to fetch conversation context when it's not available (e.g., in personal tabs).
  //         // This is expected behavior and we handle it gracefully.
  //         try {
  //           const context = await microsoftTeams.app.getContext();
  //           // Check for subEntityId (v1 compatibility) or subPageId (v2)
  //           const subEntityId = (context as any)?.subEntityId || 
  //                              context?.page?.subPageId;
            
  //           if (subEntityId) {
  //             const decodedPath = decodeURIComponent(subEntityId);
  //             navigate(`/${decodedPath}`);
  //           }
  //         } catch (contextError: any) {
  //           // Handle 404 or other errors gracefully - this can happen when:
  //           // - App is running in a personal tab (no conversation context)
  //           // - Conversation doesn't exist or user doesn't have access
  //           // - App is running outside of a conversation context
  //           // The 404 from /api/chatsvc/... is expected in these scenarios
  //           console.warn('Could not get Teams context (this may be expected in some contexts):', contextError?.message || contextError);
  //           // Continue with normal app flow even if context fetch fails
  //         }
          
  //         sessionStorage.setItem('hasLoaded', 'true');
  //         setIsFirstLoad(false);
  //       } catch (initError: any) {
  //         console.warn('Teams initialization failed:', initError?.message || initError);
  //         // Continue with normal app flow even if initialization fails
  //         sessionStorage.setItem('hasLoaded', 'true');
  //         setIsFirstLoad(false);
  //       }
  //     };
      
  //     initializeTeams();
  //   } else {
  //     setIsFirstLoad(false);
  //   }
  // }, [navigate, isFirstLoad]);

  // useEffect(() => {
  //   console.log('isHiringManager', isHiringManager);
  //   if (!isHiringManager) return;
  //   const path = location?.pathname || '';
  //   if (path === NavigationPath.defaultPath || path === NavigationPath.hiring) {
  //     navigate(`/overview`, { replace: true });
  //   }
  // }, [isHiringManager, location?.pathname, navigate]);

  useEffect(() => {
  if (!isHiringManager) return;

  const path = location?.pathname || '';
  const hasDeepLink =
    path !== NavigationPath.defaultPath &&
    path !== NavigationPath.hiring;

  if (!hasDeepLink) {
    navigate(`/overview`, { replace: true });
  }
}, [isHiringManager, location.pathname, navigate]);

  if (!isHiringManager) {
    return (
      <Ic2fxComponentWrapper
        componentType={Ic2fxComponentType.errorScreen}
        errorType={Ic2fxErrorType.forbidden}
      />
    );
  }

  return (
    <Routes>
      <Route path={NavigationPath.hiring} element={<Navigate to={`/overview`} replace />} />
      <Route path={`/overview`} element={<HiringOverview />} />
      <Route path={`/candidatePipeline`} element={<CandidatePipeline />} />
      <Route path={`/candidateProfile`} element={<CandidateProfile />} />
    </Routes>
  );
};

const mapStateToProps = (state: IStoreState) => ({
  ssoToken: state.auth?.ssoToken,
});

const mapDispatchToProps = {
  saveSSOToken: loginUserSuccess,
};


const HiringManagerRoutes = connect(mapStateToProps, mapDispatchToProps)(HiringManagerRoutesUnconnected);
export default HiringManagerRoutes;


